import { React } from 'react';
import PDFViewer from '../../components/AlmanacViewer';

function StudentAlmanac() {
  return (<div style={{ padding: "1rem" }}><PDFViewer /></div>);
}

export default StudentAlmanac;
